// extracted by mini-css-extract-plugin
export default {"link":"FileInfoPanelItem_link__4PPSD"};